import React from "react";

import { Grid } from "@mui/material";
import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { BsChatSquareText } from "react-icons/bs";

import { CartonView } from "../../../../../../models/carton";
import { DefaultTooltip } from "../../../../Tooltip";
import useStyles from "../../../styles";
import { CommentModalHandles } from "../../CreateCommentModal";

interface Props {
  carton?: CartonView;
  show?: boolean;
  commentRef: React.RefObject<CommentModalHandles>;
}

const CommentButton = (props: Props) => {
  const { carton, show, commentRef } = props;

  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (!carton || !show) return null;

  const onClick = () => commentRef.current?.open(carton?.sscc);

  return (
    <Grid item data-cy="Comment-sscc" className={classes.roundButton}>
      <DefaultTooltip title={translate("addAComment")}>
        <div className={classes.printButton} onClick={onClick}>
          <BsChatSquareText
            size={GridConstants.defaultRowActionSize}
            color={GridConstants.defaultColorIcon}
          />
        </div>
      </DefaultTooltip>
    </Grid>
  );
};

export default CommentButton;
